import { Component, Input } from '@angular/core';
import { Company } from '../../models/company';
import { User } from '../../models/user';
import * as UserActions from '../../actions/user.actions';

// ngrx/store
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers'

@Component({
  selector: 'flex-control',
  templateUrl: 'flex-control.html'
})
export class FlexControlComponent {
  @Input() company: Company;
  @Input() user: User;
  ticker: string;
  useFlex: boolean;


  constructor(private store: Store<fromRoot.State>) {
  }
  ngOnChanges() {
    if (!this.company || !this.user) return;
    this.ticker = this.company.ticker.replace('.', '')
    if (this.user.flexes) {
      this.useFlex = this.user.flexes[this.ticker] ? this.user.flexes[this.ticker].useFlex : false;
    } else {
      this.useFlex=false;
    }
  }

  toggleFlex(event) {
    const newValue = event.value;
    this.useFlex = newValue;


    this.store.dispatch(new UserActions.ToggleFlex({
        ticker: this.ticker,
        useFlex: newValue
      }));
  }

}



// WEBPACK FOOTER //
// ./src/components/flex-control/flex-control.ts